var _excluded = ["columns", "gutterSpace", "alignItems", "isCentered", "isReversed", "isAsymmetricDivided", "isFitContentColumn", "autoFitColWidth", "hasOverflowHidden", "hasBorderRadiusInherited", "hasHorizontalScroll", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { Children } from "react";
import styled, { css } from "styled-components";
import getColumnAsymetricDividedStyles from "../../../helpers/getColumnAsymetricDividedStyles";
import breakpoint from "../../../utils/breakpoint";
import space from "../../../utils/space";
import throwError from "../../../utils/throwError";
import unit from "../../../utils/unit";
var columnCenteredStyles = function columnCenteredStyles(numberOfColumns, isFitContentColumn) {
  var span = 2;
  var totalNumberOfColumns = numberOfColumns * span;
  var styles;
  for (var numberOfItemsInLastRow = 1; numberOfItemsInLastRow < numberOfColumns; numberOfItemsInLastRow += 1) {
    for (var indexOfItemInLastRow = 1; indexOfItemInLastRow <= numberOfItemsInLastRow; indexOfItemInLastRow += 1) {
      var indexFromTheEndOfItem = numberOfItemsInLastRow - indexOfItemInLastRow + 1;
      styles = css(["", ";> :nth-child( ", "n+", " ):nth-last-child(", "){grid-column:", " / span ", ";}"], styles, numberOfColumns, indexOfItemInLastRow, indexFromTheEndOfItem, numberOfColumns - indexFromTheEndOfItem + indexOfItemInLastRow, span);
    }
  }
  return css(["", ";grid-template-columns:repeat( ", ",", " );> *{grid-column:span ", ";}"], styles, totalNumberOfColumns, isFitContentColumn ? "max-content" : "1fr", span);
};
var columnBasicStyles = function columnBasicStyles(numberOfColumns, isFitContentColumn, autoFitColWidth) {
  if (!numberOfColumns && !autoFitColWidth) {
    return null;
  }
  return autoFitColWidth ? css(["grid-template-columns:repeat( auto-fit,minmax(", ",1fr) );"], unit(autoFitColWidth)) : css(["grid-template-columns:repeat( ", ",", " );"], numberOfColumns, isFitContentColumn ? "max-content" : "1fr");
};
var columnStyles = function columnStyles(numberOfColumns, isCentered, isReversed, isAsymmetricDivided, isFitContentColumn, autoFitColWidth) {
  if (isCentered && numberOfColumns) {
    if (numberOfColumns.small) {
      var numberOfColumnsBreakpoint = numberOfColumns;
      return css(["", "{", "}", "{", "}", "{", "}"], breakpoint("small", "medium"), columnCenteredStyles(numberOfColumnsBreakpoint.small, !!isFitContentColumn), breakpoint("medium", "large"), columnCenteredStyles(numberOfColumnsBreakpoint.medium, !!isFitContentColumn), breakpoint("large"), columnCenteredStyles(numberOfColumnsBreakpoint.large, !!isFitContentColumn));
    }
    return css(["", ""], columnCenteredStyles(numberOfColumns, !!isFitContentColumn));
  }
  if (numberOfColumns && numberOfColumns.small) {
    var _numberOfColumnsBreakpoint = numberOfColumns;
    return css(["", " ", " ", "{", " ", "}", "{", " ", "}"], columnBasicStyles(_numberOfColumnsBreakpoint.small, !!isFitContentColumn, autoFitColWidth), getColumnAsymetricDividedStyles(_numberOfColumnsBreakpoint.small, isReversed, isAsymmetricDivided), breakpoint("medium"), columnBasicStyles(_numberOfColumnsBreakpoint.medium, !!isFitContentColumn, autoFitColWidth), getColumnAsymetricDividedStyles(_numberOfColumnsBreakpoint.medium, isReversed, isAsymmetricDivided), breakpoint("large"), columnBasicStyles(_numberOfColumnsBreakpoint.large, !!isFitContentColumn, autoFitColWidth), getColumnAsymetricDividedStyles(_numberOfColumnsBreakpoint.large, isReversed, isAsymmetricDivided));
  }
  return css(["", " ", ""], columnBasicStyles(numberOfColumns, !!isFitContentColumn, autoFitColWidth), getColumnAsymetricDividedStyles(numberOfColumns, isReversed, isAsymmetricDivided));
};
var gutterBasicStyles = function gutterBasicStyles(gutterSpace) {
  if (gutterSpace.x) {
    return css(["grid-column-gap:", ";grid-row-gap:", ";"], space(gutterSpace.x), space(gutterSpace.y));
  }
  return css(["grid-gap:", ";"], space(gutterSpace));
};
var gutterStyles = function gutterStyles(gutterSpace) {
  if (gutterSpace.small) {
    return css(["", ";", "{", ";}", "{", ";}"], gutterBasicStyles(gutterSpace.small), breakpoint("medium"), gutterBasicStyles(gutterSpace.medium), breakpoint("large"), gutterBasicStyles(gutterSpace.large));
  }
  return css(["", ";"], gutterBasicStyles(gutterSpace));
};
var StyledGridOrg = styled.div.withConfig({
  componentId: "sc-1ju0p0f-0"
})(function (_ref) {
  var $columns = _ref.$columns,
    $gutterSpace = _ref.$gutterSpace,
    $alignItems = _ref.$alignItems,
    $isCentered = _ref.$isCentered,
    $isReversed = _ref.$isReversed,
    $isAsymmetricDivided = _ref.$isAsymmetricDivided,
    $isFitContentColumn = _ref.$isFitContentColumn,
    $autoFitColWidth = _ref.$autoFitColWidth,
    $hasOverflowHidden = _ref.$hasOverflowHidden,
    $hasBorderRadiusInherited = _ref.$hasBorderRadiusInherited,
    $hasHorizontalScroll = _ref.$hasHorizontalScroll;
  return css(["", " ", ";display:grid;", " ", ";", ";", ";"], columnStyles($columns, $isCentered, $isReversed, $isAsymmetricDivided, $isFitContentColumn, $autoFitColWidth), gutterStyles($gutterSpace), $alignItems && css(["align-items:", ";"], $alignItems), $hasOverflowHidden ? css(["overflow:hidden;"]) : null, $hasBorderRadiusInherited ? css(["border-radius:inherit;"]) : null, $hasHorizontalScroll ? css(["grid-auto-flow:column;grid-auto-columns:1fr;overflow:auto;"]) : null);
});
function GridOrg(_ref2) {
  var columns = _ref2.columns,
    gutterSpace = _ref2.gutterSpace,
    alignItems = _ref2.alignItems,
    isCentered = _ref2.isCentered,
    isReversed = _ref2.isReversed,
    isAsymmetricDivided = _ref2.isAsymmetricDivided,
    isFitContentColumn = _ref2.isFitContentColumn,
    autoFitColWidth = _ref2.autoFitColWidth,
    hasOverflowHidden = _ref2.hasOverflowHidden,
    hasBorderRadiusInherited = _ref2.hasBorderRadiusInherited,
    hasHorizontalScroll = _ref2.hasHorizontalScroll,
    children = _ref2.children,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  if (!columns && !autoFitColWidth && !hasHorizontalScroll) {
    throwError('"GridOrg" has to have defined "columns" or "autoFitColWidth" or "hasHorizontalScroll" prop!');
  }
  return /*#__PURE__*/React.createElement(StyledGridOrg, _extends({
    $columns: columns,
    $gutterSpace: gutterSpace,
    $alignItems: alignItems,
    $isCentered: !!isCentered,
    $isReversed: !!isReversed,
    $isAsymmetricDivided: !!isAsymmetricDivided,
    $isFitContentColumn: !!isFitContentColumn,
    $autoFitColWidth: autoFitColWidth,
    $hasOverflowHidden: hasOverflowHidden,
    $hasBorderRadiusInherited: hasBorderRadiusInherited,
    $hasHorizontalScroll: hasHorizontalScroll
  }, restProps), isReversed ? Children.toArray(children).reverse() : children);
}
export default GridOrg;